import {
  FlowTransitionNodeProps,
  TRANSITION_HEIGHT,
  TRANSITION_WIDTH,
  useCreateNewTransitionResult,
  useCreateNewTransitionAction,
  useFlow,
} from 'entities/flow'

import styles from './FlowTransitionNode.module.css'
import classNames from 'classnames'
import { useState } from 'react'
import { TransitionEdit } from '../TransitionForm/TransitionEdit/TransitionEdit'
import { TransitionComponentPanel } from '../TransitionComponentPanel/TransitionComponentPanel'
import { useTransitionContext } from '../model'
import { Handle, Position } from 'reactflow'
import { useHasWritePermission } from 'entities/permissions'
import i18n from 'shared/i18n/i18n'
import { useProjectContext } from 'features/head/context'

export const FlowTransitionNode = ({
  data,
  id,
  isConnectable,
}: FlowTransitionNodeProps) => {
  const hasWritePermission = useHasWritePermission()

  const [editOpen, setEditOpen] = useState(false)
  const { data: flow } = useFlow()
  const { setTransition } = useTransitionContext()
  const empty = !data.actionId
  const transition = {
    ...data,
    id,
  }

  const createNewTransitionAction = useCreateNewTransitionAction()
  const createNewTransitionResult = useCreateNewTransitionResult()

  const { isMaster } = useProjectContext()
  const isWritable = isMaster

  return (
    <>
      <div
        className={classNames(styles.wrapper, {
          [styles['empty-wrapper']]: empty,
        })}
        style={{
          height: TRANSITION_HEIGHT,
          width: TRANSITION_WIDTH,
        }}
        onClick={
          empty && hasWritePermission && isWritable
            ? () => setEditOpen(true)
            : undefined
        }
      >
        {empty ? (
          `+ ${i18n.t('transition')}`
        ) : (
          <TransitionComponentPanel
            onAddResult={() => {
              createNewTransitionResult({
                fromTransition: transition,
              })
            }}
            onAddAction={() => {
              createNewTransitionAction({
                fromTransitionPosition: transition.position,
                onSuccess: (newTransition) => setTransition(newTransition),
                flow,
              })
            }}
            addOptionsVisible={!empty && hasWritePermission && isWritable}
            transition={transition}
          />
        )}
      </div>
      <Handle
        style={{
          opacity: 0,
        }}
        type="source"
        position={Position.Right}
      />
      {editOpen && hasWritePermission && isWritable && (
        <TransitionEdit
          isOpen
          onClose={() => setEditOpen(false)}
          transition={transition}
        />
      )}
    </>
  )
}
